import type { SVGProps } from '../types';

export const VaultIcon = (props: SVGProps) => {
  const { title = 'vault-icon', className = '', ...restProps } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={title}
      className={`fill-current ${className}`}
      {...restProps}
    >
      <title>{title}</title>
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.648 1.833h10.704c.483 0 .9 0 1.244.028.362.03.723.095 1.07.272a2.75 2.75 0 0 1 1.201 1.202c.177.347.242.707.272 1.07.028.343.028.76.028 1.243v7.954c0 .483 0 .9-.028 1.243-.03.363-.095.723-.272 1.07a2.75 2.75 0 0 1-1.202 1.202c-.346.177-.707.242-1.07.272-.343.028-.76.028-1.243.028H5.648c-.483 0-.9 0-1.243-.028-.363-.03-.723-.095-1.07-.272a2.75 2.75 0 0 1-1.202-1.202c-.177-.347-.242-.707-.271-1.07a16 16 0 0 1-.029-1.243V5.648c0-.483 0-.9.029-1.243.03-.363.094-.723.271-1.07a2.75 2.75 0 0 1 1.202-1.202c.347-.177.707-.242 1.07-.272.343-.028.76-.028 1.243-.028M4.554 3.69c-.249.02-.341.055-.387.078a.9.9 0 0 0-.4.4c-.023.046-.058.138-.078.387-.021.26-.022.6-.022 1.13v7.883c0 .528 0 .87.022 1.13.02.248.055.34.078.386a.9.9 0 0 0 .4.4c.046.024.138.058.387.078.26.022.601.022 1.13.022h10.633c.528 0 .87 0 1.13-.022.248-.02.34-.054.386-.078a.9.9 0 0 0 .4-.4c.024-.046.058-.138.079-.387.02-.26.021-.6.021-1.13V5.684c0-.528 0-.87-.021-1.13-.02-.248-.055-.34-.078-.386a.9.9 0 0 0-.401-.4c-.045-.023-.138-.058-.387-.078-.26-.022-.6-.022-1.13-.022H5.685c-.529 0-.87 0-1.13.022M16.96 5.043v9.166h-1.834V5.042zM8.25 8.25a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75M5.042 9.625a3.208 3.208 0 1 1 6.416 0 3.208 3.208 0 0 1-6.416 0m-.458 10.542v-1.834h4.583v1.834zm8.25-1.834h4.583v1.834h-4.584z"
        fill="inherit"
      />
    </svg>
  );
};
